<template>
  <div class="upsell-new col-lg-6">
    <h1 class="page-title">Novo funil</h1>

    <form-group
      id="name"
      label="Nome do funil"
      v-model="form.name"
      :errors="errors.name"
      placeholder="Ex: Lançamento 01"
      required
    />
    <div class="d-flex justify-content-end mb-5">
      <small
        class="text-secondary"
        :class="{
          'text-danger': form.name && form.name.length > 200
        }"
      >
        {{ `${form.name ? form.name.length : 0}/200` }}
      </small>
    </div>

    <action-dispatcher
      v-if="productId"
      action="product/getProduct"
      :parameters="productId"
    >
      <action-dispatcher
        v-if="product"
        :action="isSignature ? 'plan/get' : 'offer/get'"
        :parameters="{ product_id: productId, limit: 1000 }"
      >
        <form-group
          v-if="isSignature"
          slim
          select
          id="offer-select"
          label="Plano*"
          v-model="form.plan_id"
          placeholder="Selecionar o plano..."
          :options="allOffers"
          :errors="errors.plan_id"
        />
        <form-group
          v-else
          slim
          select
          id="offer-select"
          label="Oferta"
          v-model="form.offer_id"
          placeholder="Selecione a oferta..."
          :options="allOffers"
          :errors="errors.offer_id"
        />
      </action-dispatcher>
    </action-dispatcher>

    <div class="d-flex align-items-center pt-6">
      <button class="btn btn-outline-secondary btn-block mr-6" @click="cancel">
        Cancelar
      </button>
      <button
        class="btn btn-block my-0 ml-6"
        :class="isValid ? 'btn-primary' : 'btn-secondary'"
        @click="submit"
        :disabled="!isValid"
      >
        <loading :show="loading">
          Salvar
        </loading>
      </button>
    </div>
  </div>
</template>

<script>
import { formFields } from "@/functions/helpers.js";
import get from "lodash/get";
import { mapState } from "vuex";

export default {
  props: {
    productId: {
      type: [Number, String],
      default: null
    },
    funnel: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      loading: false,
      selectedProductId: get(this.funnel, "product.id"),
      ...formFields(
        [
          "name",
          "product_id",
          "offer_id",
          "plan_id",
          "method_payment",
          "is_active",
          "is_end"
        ],
        {
          product_id: this.productId,
          is_end: false,
          is_active: true,
          method_payment: "card",
          offer_id: get(this.funnel, "offer.id"),
          plan_id: get(this.funnel, "plan.id"),
          ...this.funnel
        }
      )
    };
  },
  computed: {
    ...mapState("product", ["product", "products", "paymentMethods"]),
    ...mapState("offer", ["offers"]),
    ...mapState("plan", ["plans"]),
    ...mapState("funnel", ["funnels"]),
    isSignature() {
      if (this.productId) {
        return this.product.type_product === "signature";
      }
      if (this.selectedProductId && this.selectedProduct) {
        return this.selectedProduct.type_product === "signature";
      }
      return false;
    },
    activeFunnels() {
      return this.funnels.filter(f => f.is_active);
    },
    selectedProduct() {
      return this.products.find(p => p.id === this.selectedProductId);
    },
    allOffers() {
      let product = null;
      if (this.product && this.product.id) {
        product = this.product;
      } else if (this.selectedProductId && this.selectedProduct) {
        product = this.selectedProduct;
      } else {
        return [];
      }

      const offers =
        product.type_product === "signature" ? this.plans : this.offers;
      return offers.filter(o => o.status === "active");
    },
    isValid() {
      return (
        this.form.product_id &&
        this.form.name &&
        this.form.name?.length < 201 &&
        (this.form.plan_id || this.form.offer_id) &&
        this.form.method_payment
      );
    }
  },
  methods: {
    selectProduct(value) {
      this.selectedProductId = null;
      setTimeout(() => {
        this.selectedProductId = value;
      }, 1);
    },
    cancel() {
      this.$router.go(-1);
    },
    submit() {
      this.loading = true;

      const data = this.form;
      if (this.productId) {
        data.product_id = this.productId;
      }

      let action = "funnel/post";
      if (this.funnel.id) {
        data.id = this.funnel.id;
        action = "funnel/put";
      }

      this.$store
        .dispatch(action, data)
        .then(response => {
          if (this.$route.name !== "product-upsell-tree") {
            let tree = this.form.parent
              ? this.form.parent
              : response.data.tree_id;
            this.$router.push({
              name: "product-upsell-tree",
              params: { id: this.$route.params.id, tree: tree }
            });
          }
        })
        .then(() => {
          this.$message.success("Salvo com sucesso");
        })
        .catch(error => {
          this.errors = error.response.data;
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
